// Referências externas
import React, {useEffect} from "react";
import { useReactToPrint } from "react-to-print";


// Estilo
import './styles.css';

 const ComponentToPrint = React.forwardRef((props, ref) => {
    return (
      <div className="relativeCSS" ref={ref}>
        <table className="testClass">
          <thead>
            <tr>
              <th className="column1">Test Name</th>
              <th>Test</th>
            </tr>
          </thead>
        </table>
      </div>
    );
  });


export default function Teste() {
    const componentRef = React.useRef(null);
  
    const printFn = useReactToPrint({
      contentRef: componentRef,
      documentTitle: "AwesomeFileName",
    });

    useEffect(() => {
        document.title = `SGC Brazil Solution Teste`;
    }, []);

    return (
        <div>
          <button onClick={() => printFn()}>Imprimir</button>
          
          <ComponentToPrint ref={componentRef} />
        </div>
      );
}